import React from 'react';
import { TentIcon, QrCodeIcon, PercentIcon, ArrowRightIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
type FairPromotionProps = {
  fair: any;
  onClose: () => void;
};
export const FairPromotion: React.FC<FairPromotionProps> = ({
  fair,
  onClose
}) => {
  if (!fair) return null;
  // Format date range for display
  const formatDateRange = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    // Format options
    const options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };
    return `${start.toLocaleDateString('en-US', options)} - ${end.toLocaleDateString('en-US', options)}`;
  };
  return <div className="bg-gradient-to-r from-amber-600/90 to-amber-700/90 backdrop-blur-sm border border-amber-500/50 rounded-xl p-4 shadow-xl relative overflow-hidden" data-id="element-3372" data-mp="f8b8q6jwtzla">
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/20 rounded-full filter blur-3xl -z-10" data-id="element-3373" data-mp="1awg6syd1bp3"></div>
      <div className="flex items-center" data-id="element-3374" data-mp="69pirqc3ziah">
        <div className="hidden sm:block mr-4" data-id="element-3375" data-mp="31h2m3kxh5eig">
          <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center" data-id="element-3376" data-mp="31jyktbh5c77y">
            <QrCodeIcon size={40} className="text-amber-600" data-id="element-3377" data-mp="2xilez1e20411" />
          </div>
        </div>
        <div className="flex-1" data-id="element-3378" data-mp="3bfidlp0eypsh">
          <div className="flex items-center mb-1" data-id="element-3379" data-mp="36hgk0a5d382r">
            <TentIcon size={18} className="text-white mr-2" data-id="element-3380" data-mp="36hqcq5hsjtc5" />
            <h3 className="text-white font-bold text-lg" data-id="element-3381" data-mp="2ir32hdkekrmf">{fair.name}</h3>
          </div>
          <div className="flex flex-wrap gap-2 mb-2 text-xs text-amber-100" data-id="element-3382" data-mp="2dst6x1urnp0a">
            <div className="flex items-center" data-id="element-3383" data-mp="2dqot9s72fbmt">
              <MapPinIcon size={12} className="mr-1" data-id="element-3384" data-mp="2sih69xje0dld" />
              {fair.location}
            </div>
            <div className="flex items-center" data-id="element-3385" data-mp="2npo158k0b38r">
              <CalendarIcon size={12} className="mr-1" data-id="element-3386" data-mp="2now55wmhz3hy" />
              {formatDateRange(fair.startDate, fair.endDate)}
            </div>
          </div>
          <div className="flex items-center mb-3" data-id="element-3387" data-mp="1v109mv8nzhmr">
            <PercentIcon size={16} className="text-amber-200 mr-1" data-id="element-3388" data-mp="3v4azr1rh2wua" />
            <p className="text-white text-sm font-medium" data-id="element-3389" data-mp="3v41879qs4hmh">
              ¡Escanea el código QR en la feria para obtener un 40% de descuento
              en todas las cotizaciones!
            </p>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-3390" data-mp="8qt846svlsld">
            <button className="bg-white text-amber-700 hover:bg-amber-100 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors flex items-center" data-id="element-3391" data-mp="cqjvs1n3vslo">
              Crear Cotización
              <ArrowRightIcon size={14} className="ml-1" data-id="element-3392" data-mp="3h408hxm93g8l" />
            </button>
            <button onClick={onClose} className="bg-white/20 text-white hover:bg-white/30 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors" data-id="element-3393" data-mp="3l63lwrshcuwi">
              Descartar
            </button>
          </div>
        </div>
        <button onClick={onClose} className="absolute top-2 right-2 text-white/80 hover:text-white bg-black/10 hover:bg-black/20 rounded-full p-1" data-id="element-3394" data-mp="10gnxu4knbkak">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-3395" data-mp="15h27ts5t54b8">
            <line x1="18" y1="6" x2="6" y2="18" data-id="element-3396" data-mp="1akl5i8ya1rdj"></line>
            <line x1="6" y1="6" x2="18" y2="18" data-id="element-3397" data-mp="15sl2u8qtokd9"></line>
          </svg>
        </button>
      </div>
    </div>;
};